// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__--odj","label":"styles_label__3ztTF"};